
import React from 'react';
import './index.css';

const MapSection = ({ config }) => {
    const contact = config.footer?.contact || {};
    const name = config.name;
    const mapUrl = config.mapUrl || `https://www.google.com/maps/embed/v1/place?key=YOUR_API_KEY&q=${encodeURIComponent(contact.address || name)}`;

    // Fallback static map if no key provided
    const fallbackMap = `https://maps.google.com/maps?q=${encodeURIComponent(contact.address || name)}&t=&z=13&ie=UTF8&iwloc=&output=embed`;

    return (
        <section id="map" className="map-section pad-top-100 pad-bottom-100">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-5 col-md-12">
                        <div className="map-content wow fadeInLeft">
                            <span className="map-kicker">{contact.sub_heading}</span>
                            <h2 className="map-title">{contact.heading}</h2>
                            <p className="map-desc">
                                {contact.description}
                            </p>
                            <div className="location-card">
                                <div className="location-icon">📍</div>
                                <div className="location-info">
                                    <h4>Our Address</h4>
                                    <p>{contact.address}</p>
                                </div>
                            </div>
                            <div className="location-card">
                                <div className="location-icon">📞</div>
                                <div className="location-info">
                                    <h4>Contact Details</h4>
                                    <p>{contact.phone}</p>
                                    <p>{contact.email}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-12">
                        <div className="map-frame wow fadeInRight">
                            <iframe
                                title="Store Location"
                                src={fallbackMap}
                                width="100%"
                                height="450"
                                style={{ border: 0, borderRadius: '20px', boxShadow: '0 20px 40px rgba(0,0,0,0.1)' }}
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            ></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default MapSection;
